import {ListItem, Stack, TextField} from "@mui/material";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import ListItemIcon from "@mui/material/ListItemIcon";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import Divider from "@mui/material/Divider";

const BlockedAlerts = ({blocked}) => {

    const reallyBlocked = blocked.filter((pt) => (pt.blockBb + pt.blockBf) > 0);

    const generateLabel = (blockBb, blockBf) => {
        if (blockBb > 0 && blockBf) {
            return "Barras bloqueadas"
        }
        if (blockBf > 0) {
            return "Barras frontales bloqueadas"
        }
        if (blockBb > 0) {
            return "Barras traseras bloqueadas"
        }
    }

    return (
        <Stack divider={<Divider orientation="horizontal" flexItem />}>
            <Typography variant={"body1"} sx={{ py: 1, pl: 2 }}>Alarmas</Typography>
            <List dense={true} sx={{bgcolor: 'background.paper', height: "400px", overflow: "scroll"}}>
                {reallyBlocked.map((bl, i) => (
                    <ListItem key={i}>
                        <ListItemIcon>
                            <ReportProblemIcon/>
                        </ListItemIcon>
                        <ListItemText
                            primary={generateLabel(bl.blockBb, bl.blockBf)}
                            secondary={"Eco: " + bl.unit_number + ", " + (bl.blockBb + bl.blockBf) + " min."}
                        />
                    </ListItem>
                ))}
            </List>
        </Stack>
    );

}


export default BlockedAlerts